// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__UTGqW","col":"styles_col__2d04h"};